import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";

@Injectable()
export class ValidaManSusComercioService implements CanActivate {
  constructor(private router: Router) {}

  canActivate() {
    if (sessionStorage.getItem("listSusComercio") != null) {
      return true;
    } else {
      // Si no esta activa la sesion, redirecciona al login
      this.router.navigate(["inicio"]);
      return false;
    }
  }
}
